//  ---------------------------------------------------------------------------
//  DO NOT EDIT THIS FILE! This File was auto-generated.
//  ---------------------------------------------------------------------------
define('root/Assets/Js/Templates',[
	'root/Assets/Templates/Content/History/Js/History',
	'root/Assets/Templates/Content/OpenPositions/Js/OpenPositions',
	'root/Assets/Templates/Content/PartnerSlider/Js/PartnerSlider',
	'root/Assets/Templates/Content/ProjectsNav/Js/ProjectsNav',
	'root/Assets/Templates/Content/Slider/Js/Slider',
	'root/Assets/Templates/Content/TeaserBlock/Js/TeaserBlock',
	'root/Assets/Templates/Html/Menu/Js/Menu'
], function () {
	return arguments;
});

